import { createStyles, Theme } from '@zn-material-ui'

export default (theme: Theme) =>
  createStyles({
    selectContainer: {
      position: 'relative',
      marginBottom: 44,
      '& .fullSelect': {
        width: '100% !important',
        marginLeft: '0px !important',
        padding: '0px !important',
        overflow: 'hidden',
      },
    },
    select: {
      display: 'flex',
      fontSize: '18px',
      color: theme.palette.text.primary,
      letterSpacing: '0.8px',
      borderBottom: '1px solid #E9EBF0',
      alignItems: 'center',
      cursor: 'pointer',
      '& .root': {
        display: 'flex',
        width: 200,
        fontSize: 18,
        paddingLeft: 20,
        paddingRight: 32,
        position: 'relative',
        '&:focus': {
          background: 'none',
        },
      },
      '& .icon': {
        top: 'calc(50% - 12px)',
        right: 0,
        color: '#363C46',
        position: 'absolute',
        pointerEvents: 'none',
      },
      '& .arrowIcon': {
        color: '#363C46',
        pointerEvents: 'none',
        position: 'absolute',
        right: 0,
        cursor: 'pointer',
      },
    },
    menuItemRoot: {
      width: '220px',
      marginRight: '-17px',
    },
    menuItemName: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '95%',
      lineClamp: 1,
      whiteSpace: 'nowrap',
      minHeight: 19,
    },
    button: {
      width: '220px',
      height: '48px',
      marginTop: '120px',
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.primary.main,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
      },
    },
    option: {
      width: 272,
      marginLeft: 90,
      background: theme.palette.secondary.main,
      zIndex: 999,
      border: '1px solid rgba(0, 0, 0, 0.1)',
      marginTop: 2,
      borderRadius: '0 0 3px 3px',
      position: 'absolute',
      /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
      // '&::-webkit-scrollbar': {
      //     width: "4px",
      //     height: '56px',
      //     backgroundColor: 'rgba(0, 0, 0, 0.14)'
      // },
      /*定义滚动条轨道 内阴影+圆角*/
      '&::-webkit-scrollbar-track': {
        WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
        borderRadius: '10px',
        backgroundColor: '#F5F5F5',
      },
      /*定义滑块 内阴影+圆角*/
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '2px',
        WebkitBoxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.14)',
        backgroundColor: 'rgba(0, 0, 0, 0.14)',
        width: '4px',
        height: '56px',
      },
      '& .listPad': {
        padding: 0,
      },
      '& .selected': {
        '&:hover': {
          backgroundColor: '#F5F5F5',
          color: theme.palette.text.secondary,
        },
        backgroundColor: '#F5F5F5',
      },
      '& .dListItem': {
        cursor: 'pointer',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#666666',
        height: 40,
        padding: '0 !important',
        fontSize: 12,
        boxSizing: 'border-box',
      },
    },
    listItem: {
      height: '56px',
      padding: '0 0 0 31px !important',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.primary.main,
      },
    },
    hideBorder: {
      opacity: 0,
    },
    optionMask: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
    dropDownList: {
      width: 150,
      marginLeft: 0,
      border: '1px solid rgba(0, 0, 0, 0.1)',
      borderBottom: 'none',
      overflow: 'hidden',
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.30)',
    },
  })
